import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { competitionTypeOptions } from '@/module/Nomen/CompetitionType/model/CompetitionTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type CompetitionTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function CompetitionTypeSelectControl<T extends FieldValues>(props: CompetitionTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(competitionTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
